import { Market, PrivacySettingToggles } from '../types/market';
import { fr as adConfig } from '../ads';

const market: Market = {
  countryCode: 'fr',
  active: true,
  permanentRedirect: true,
  sitename: 'leDénicheur',
  redirectHosts: ['m.ledenicheur.fr', 'www.ledenicheur.fr'],
  useClassicUrls: true,
  superSearchEndpoint: 'https://search.cloud.pji.nu/rfe',
  trackerProxy: 'rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com',
  classicProxy: {
    host: 'int-classic-fr.prisjakt.io',
    port: 8080,
  },
  hrefLang: ['fr'],
  locale: 'fr-fr',
  sites: {
    production: 'https://ledenicheur.fr',
    classic: 'https://classic.ledenicheur.fr',
    analytics: 'https://classic.ledenicheur.fr/analytics/store',
    forum: undefined,
    brands: undefined,
    mobile: 'https://m.ledenicheur.fr',
  },
  api: {
    default: 'http://int-api-fr.prisjakt.io:8080/v1',
  },
  campaigns: {
    base:
      'https://search-pj-campaigns-index-oyaq7ruf3du2owxiiiuhyqcgcm.eu-west-1.es.amazonaws.com',
    previousCampaignDates: {
      '2': '2019-11-29', // BF
      '6': '2019-12-02', // CM
      '12': '2020-01-09', // January sale
    },
  },
  googleTagManager: 'GTM-KD9S55X',
  translation: 'fr',
  timezone: 'Europe/Paris',
  currencyCode: 'EUR',
  url: {
    campaigns: '/actu',
    legacy: {
      brand: '/brand.php',
      category: '/category.php',
      fight: '/fight.php',
      forum: undefined,
      info: '/info.php',
      lists: '/lists.php',
      minhembio: undefined,
      plugin: '/plugins/',
      product: '/product.php',
      raw: '/raw.php',
      store_info: '/shop.php',
      user_login: '/login/login.php',
      mobile_site: 'https://m.ledenicheur.fr',
    },
  },
  socialNetworks: {
    instagram: {
      link: 'https://www.instagram.com/ledenicheur/',
    },
    facebook: {
      link: 'https://www.facebook.com/leDenicheurFR',
      clientID: '1613576928948000',
      clientSecret: '38aae17a81bffe428cf197d62c01e94e',
      callbackURL: `/_internal/auth/facebook/callback`,
    },
    twitter: {
      link: 'https://twitter.com/leDenicheur',
      consumerKey: 'jdBqx8N6GqBYYh9XDXGbNQLMS',
      consumerSecret: 'mfsUD7UIRW0mriz2O3asTQtIqXPRDfYf7HNoNvqgqQELEUIIHY',
      callbackURL: `/_internal/auth/twitter/callback`,
    },
  },
  email: {
    noreply: 'noreply@ledenicheur.fr',
  },
  cdn: {
    base: 'https://pricespy-75b8.kxcdn.com',
    images: 'https://pricespy-75b8.kxcdn.com/',
  },
  routes: {
    giftGuide: {
      // HACK: Must include all current running giftGuides, hardcoded
      path: '/actu/:name(idees-cadeaux-noel)/:list?',
    },
    themes: {
      path: '/actu',
    },
    campaign: {
      path: '/actu/:name',
    },
    productCompare: {
      path: '/comparer/produits/:productIds?',
    },
    categoryIndex: {
      path: '/categories',
    },
  },
  popularCampaignFilterPaths: [
    {
      title: 'Smartphones',
      path: '?category=103&price=100-10000',
    },
    {
      title: 'Informatique',
      path: '?category=382%7C384%7C393%7C353%7C352%7C1243%7C1313%7C977',
    },
    {
      title: 'Enceintes & casques audio',
      path: '?category=148%7C1827&price=15-10000',
    },
    {
      title: 'TV',
      path: '?category=107&price=100-10000',
    },
    {
      title: 'Gros électroménager',
      path: '?category=504',
    },
    {
      title: 'Cuisine',
      path: '?category=1671&price=30-3000',
    },
    {
      title: 'Aspirateurs',
      path: '?category=515%7C520&price=100-2000',
    },
    {
      title: 'Chauffages & climatisation',
      path: '?category=507&price=30-3000',
    },
    {
      title: 'Outillage & jardinage',
      path: '?category=1064%7C1069&price=30-3000',
    },
  ],

  infoPages: [9, 5, 15, 10, 12, 4, 6, 14, 7, 8],
  infoPageMap: {
    userAgreement: 4,
    priceInformation: 5,
    privacyPolicy: 6,
    cookiePolicy: 7,
    contact: 8,
    about: 9,
    registerShop: 10,
    media: 12,
    disclaimer: 14,
    aboutReviews: 15,
    adlink: 'adlink',
    themes: 'themes',
    articles: 'articles',
    categoryIndex: 'categoryIndex',
    privacySettings: 'privacySettings',
  },
  newsletter: {
    apiUrl: 'https://api.getanewsletter.com/v3/',
    apiKey:
      '8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4',
    list: 'SAzT5',
    gansubFormId: 'gc6FyDznc6U0BEVZnott',
  },
  sourcePointCMP: {
    enabled: true,
    privacyManagerID: 374709,
    priceSpyVendorID: '5fcf917f815d9e273eb7d1fb',
  },
  apps: {
    ios: '369151774',
    android: 'se.prisjakt.pricespy',
  },
  priceList: {
    featuredAlternativePriceType: 'used_product',
    hiddenListOptions: ['not_in_mint_condition', 'pickup_only'],
  },
  ads: { active: true, ...adConfig },
  privacySettings: {
    responsive: {
      cookieVersion: '4',
      cookieUrl: '/info/cookies--i7', // Check the page name before going live with RFE
      privacyUrl: '/info/--i6', // Check the page name before going live with RFE
      privacySettingsUrl: '/privacy-settings',
    },
    desktop: {
      cookieVersion: '4',
      cookieUrl: '/info.php?t=about_cookies',
      privacyUrl: '/info.php?t=about_privacy',
      privacySettingsUrl: '/privacy.php',
    },
    mobile: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
    native: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
  },
  modules: {
    priceInfo: {
      enabled: true,
    },
    categoryInfo: {
      enabled: true,
    },
    userReviewPurchaseDate: {
      enabled: true,
      datePlaceholderFormat: 'aaaa-mm-jj',
    },
    readableProductInfo: {
      enabled: true,
    },
  },
  showClassicSwitch: false,
  trackingToggles: [
    { name: PrivacySettingToggles.BehaviourTrackingImprovement, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingMarketing, default: false },
    { name: PrivacySettingToggles.BehaviorTrackingSurveys, default: true },
    { name: PrivacySettingToggles.PersonalizedAds, default: true },
    { name: PrivacySettingToggles.Personalization, default: true },
  ],
  shopOfTheYear: {},
  cdnCache: {
    enabled: true,
    mode: 'external',
  },
  showPromoText: true,
};

export default market;
